export var referencesText = function referencesText(references) {
  var uniquePages = Array.from(new Set(references.map(function (item) {
    return item.page;
  })));
  var formattedPages = uniquePages.map(function (page, index) {
    if (index === uniquePages.length - 1) {
      return "& ".concat(page); // Last page preceded by an ampersand
    } else if (index === uniquePages.length - 2) {
      return "".concat(page, " "); // Second to last page followed by a space
    } else {
      return "".concat(page, ","); // Other pages separated by a comma
    }
  });

  return formattedPages.join(' ');
};